// Fixed rather than scaled to duration: the Hook window is only ~3s, so ticks need to stay this
// granular even on longer videos for users to see that early detail on the timeline.
const TICK_STEP_SECONDS = 3;

/**
 * getTimeTicks function
 * Returns tick times in fixed 3 second increments from 0 up to (and including) the duration.
 *
 * @param totalDuration - The total duration in seconds the axis spans
 * @returns An ascending array of tick times in seconds, starting at 0
 */
export const getTimeTicks = (totalDuration: number): number[] => {
  if (totalDuration <= 0) return [0];

  const ticks: number[] = [];
  for (let time = 0; time <= totalDuration; time += TICK_STEP_SECONDS) {
    ticks.push(time);
  }
  return ticks;
};
